export default "__VITE_ASSET__BGFghsSM__"